module.exports = __webpack_public_path__ + "img/mobile-reg-hse3.26495c17.png";